module.exports = __webpack_public_path__ + "img/pickupdumping_driving.4602f69a.svg";